
import { useBusinessTypeFeatures } from "@/hooks/useBusinessTypeFeatures";
import { useOwnerData } from "@/hooks/useOwnerData";
import { AdminLink, OwnerLink } from "@/components/layout/sidebar/navigationLinks";

export const useFilteredLinks = (
  userType: "admin" | "owner",
  links: (AdminLink | OwnerLink)[]
) => {
  const { businessTypeFeatures } = useBusinessTypeFeatures();
  const { data: ownerData } = useOwnerData();
  const businessTypeName = ownerData?.business_types?.name;

  return userType === "admin"
    ? links
    : (links as OwnerLink[]).filter(link => {
        if (!link.feature) return true;
        if (link.feature === "dashboard") return true;

        // Ne pas afficher les liens spécifiques à un type d'entreprise si ce n'est pas le bon type
        if (link.showForBusinessTypes && businessTypeName) {
          if (!link.showForBusinessTypes.includes(businessTypeName)) {
            return false;
          }
        }

        // Si requireFeature est true, vérifier que la fonctionnalité est explicitement activée
        if (link.requireFeature) {
          return businessTypeFeatures?.[link.feature] === true;
        }

        // Pour les autres liens, les afficher sauf si la fonctionnalité est désactivée
        return businessTypeFeatures?.[link.feature as keyof typeof businessTypeFeatures] !== false;
      });
};
